import dynamic from 'next/dynamic';

import { TripReviewDetailsModalProps } from './TripReviewDetailsModal';

export const DynamicTripReviewDetailsModal = dynamic<TripReviewDetailsModalProps>(
    () =>
        import('./TripReviewDetailsModal').then(({ TripReviewDetailsModal }) => {
            return TripReviewDetailsModal;
        }),
    { ssr: false },
);
